<template>
    <div>
        <el-dialog
			title="身份验证"
			:visible.sync="value"
			width="570px"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
			custom-class="verification_wrap"
            :modal-append-to-body="false"
			>
            <div slot="title">
                <span class="el-dialog__title">身份验证</span>
                <button class="el-dialog__headerbtn" @click="handleClose">
                    <i class="el-icon-close"></i>
                </button>
            </div>
			<div class="verification_con">
				<div class="verification_item">
					<p class="verification_label">安全验证</p>
					<div class="sendBox">
						<el-input placeholder="请输入验证码" v-model="code"/>
						<div class="sendBox_line"></div>
						<div class="sendBox_btn" @click="senCode" v-if="!codeTimes">
							发送验证码
						</div>
						<div class="sendBox_btn" v-else>
							重新发送{{codeTimes}}
						</div>
					</div>
				</div>
				<div class="decs" style="color: rgb(238, 167, 60);text-align:center;margin-top:12px" v-if="codeTimes"> 验证码已发送至{{phone}}，请在5分钟内输入</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="bindPhone" :disabled="!code">提交</el-button>
 			 </span>
		</el-dialog>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
    name: 'mobileDialog',
    data() {
        return {
            codeFlag: false,
            code: '',
            codeTimes: 0,
            phone: ''
        }
    },
	props: {
	    value: {
	        type: Boolean,
	        default: false
	    },
	},
    created() {
        if(localStorage.getItem('wattingTime')){
            let watTime = parseInt(localStorage.getItem('wattingTime'))
            let curTimr = Date.now()
            let chaTime = 5 * 60 * 1000
            if(curTimr-watTime>chaTime){
                this.codeFlag = true
            }else{
                this.codeFlag = false
            }
        }else{
            this.codeFlag = true
        }
    },
    methods: {
         ...mapActions('withdrawal', ['sendSms', 'checkSmsCode']),
        handleClose(done) {
			
            this.$emit('input', false)
        },
        async senCode() {
            let res = await this.sendSms()
            this.phone = res.phone
            this.codeTimes = 60
            let cutDown = () => {
                setTimeout(() => {
                    if(this.codeTimes > 0) {
                        this.codeTimes--
                        cutDown()
                    }
                },1000)
            }
            cutDown()
        },
        async bindPhone() {
            await this.checkSmsCode({ code: this.code,page: 1 })
            this.$emit('input', false)
            this.codeFlag = false
            this.$message({
                type: 'success',
                duration: 3000,
                message: '验证成功'
            })
            localStorage.setItem('wattingTime',Date.now())
        }
    }
}
</script>